import CachedIcon from '@mui/icons-material/Cached'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Box, Breadcrumbs, Card, CircularProgress, Grid, IconButton, Link, Typography } from '@mui/material'
import { Stack } from '@mui/system'
import Avatar from '@mui/material/Avatar';
import { default as React } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch, useSelector } from 'react-redux'
import { myProfileAction } from '../../redux/toolkit/profile/my-profile'
import CardContent from '@mui/material/CardContent';
import WhatsAppIcon from '../../assets/img/whatsapp.png';
import CallIcon from '../../assets/img/Call.png';
import emailLink from '../../assets/img/emaillink.png';
// import { getProfileAction } from '../../redux/profile/getPublisherProfile'

// import BodyWaperUI from '../../ui/BodyWaperUI'
// import NavbarUI from '../../ui/NavbarUI'
// import SidebarUI from '../../ui/SidebarUI'

const breadcrumb = (
    <Stack spacing={2} >
        <Breadcrumbs separator={<NavigateNextIcon fontSize="small" sx={{ color: '#fff' }} />} aria-label="breadcrumb">
            <Link underline="hover" sx={{ color: '#fff' }} color='inherit' href='/account-manager-details'>Account Manager Details</Link>
        </Breadcrumbs>
    </Stack>
)

export default function AccountManegerDetails() {
    const dispatch = useDispatch()
    // state
    const getProfileSelector = useSelector(state => state.myProfile)
    const { data, loading } = getProfileSelector


    const handleRefresh = () => {
        dispatch(myProfileAction())
    }

    return (
        <>
            <Helmet>
                <title>PSC | Support & Knowledge</title>
            </Helmet>



            <Stack direction='row' justifyContent="center" >
                <Typography variant='h5' fontFamily='Gantari' color='#1D2524' fontStyle='normal' fontWeight='600' fontSize='24px' lineHeight='33px'>Account Manager Details</Typography>
                {/* <IconButton onClick={handleRefresh}><CachedIcon /></IconButton> */}
            </Stack>
            <Grid container xs={12} sx={{ width: "100%", height: "70%", display: "flex", justifyContent: "center" }} >
                {/* <Grid xs={12} item>
                    <Box style={{ marginRight: "100px" }} sx={{ my: 2 }}>
                        {loading
                            ? <CircularProgress />
                            : <Stack xs={12} direction='row' justifyContent='space-between' >
                                <Stack sx={{ mt: 1}}>
                                    <Card sx={{ minWidth: 275 }}>
                                        <CardContent>

                                    <Typography variant='h6' fontFamily='Inter' color='#667085' fontStyle='normal' fontWeight='400' fontSize='20px' lineHeight='24px'>Manager Name</Typography>
                                    <Typography variant='h5' sx={{ fontWeight: 600 }} fontFamily='Inter' color='#344054' fontStyle='normal' fontWeight='600' fontSize='24px' lineHeight='29px'>{data?.m_name || "--"}</Typography>
                                        </CardContent>

                                    </Card>
                                </Stack>
                                <Stack sx={{ mt: 1}}>
                                    <Card sx={{ minWidth: 275 }}>
                                        <CardContent>
                                    <Typography variant='h6' fontFamily='Inter' color='#667085' fontStyle='normal' fontWeight='400' fontSize='20px' lineHeight='24px'>Email Address</Typography>
                                    <Typography variant='h5' sx={{ fontWeight: 600 }} fontFamily='Inter' color='#344054' fontStyle='normal' fontWeight='600' fontSize='24px' lineHeight='29px'>{data?.m_email || "--"}</Typography>

                                        </CardContent>

                                    </Card>
                                </Stack>
                                <Stack sx={{ mt: 1}}>
                                    <Card sx={{ minWidth: 275 }}>
                                        <CardContent>
                                    <Typography variant='h6' fontFamily='Inter' color='#667085' fontStyle='normal' fontWeight='400' fontSize='20px' lineHeight='24px'>Contact Number</Typography>
                                    <Typography variant='h5' sx={{ fontWeight: 600 }} fontFamily='Inter' color='#344054' fontStyle='normal' fontWeight='600' fontSize='24px' lineHeight='29px'>{data?.m_mobile || "--"}</Typography>

                                        </CardContent>

                                    </Card>
                                </Stack>
                            </Stack>
                        }
                        {!data && <h5 style={{ color: "red", fontSize: "20px", lineHeight: "30px" }}>“Not Account Manager is assigned to you , in case of any query please contact us<br /> through our “Support and knowledge” section”</h5>}
                    </Box>
                </Grid> */}
                <Card sx={{ my: 6, width: "50vw", borderTop: "1px solid rgb(88, 88, 88,0.3)", borderRadius: "10px", padding: "30px" }}>
                    <CardContent>
                        <Avatar sx={{ bgcolor: "black", my: 2, width: "100px", height: "100px" }}><img src={data?.m_image} width="100px" /></Avatar>
                        <Stack sx={{ my: 2 }}>
                            <Typography fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='400' fontSize='14px' lineHeight='24px'>Manager Name</Typography>
                            <Typography variant='h5' sx={{ fontWeight: 600 }} fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='600' fontSize='24px' lineHeight='29px'>{data?.m_name || "--"}</Typography>

                        </Stack>

                        <Stack sx={{ my: 2 }}>
                            <Typography fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='400' fontSize='14px' lineHeight='24px'>Email Address</Typography>
                            <Stack direction="row" alignItems="center" gap='10px'>
                                <Typography variant='h5' sx={{ fontWeight: 600 }} fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='600' fontSize='24px' lineHeight='29px'>{data?.m_email || "--"}</Typography>
                                <a href={`https://mail.google.com/mail/?view=cm&fs=1&to=${data?.m_email}`}>
                                    <img src={emailLink} width="16px" alt="Email" />
                                </a>


                            </Stack>

                        </Stack>

                        <Stack sx={{ my: 2 }}>
                            <Typography fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='400' fontSize='14px' lineHeight='24px'>Contact Address</Typography>
                            <Stack direction="row" justifyContent="space-between">
                                <Typography variant='h5' sx={{ fontWeight: 600 }} fontFamily='Inter' color='#585858' fontStyle='normal' fontWeight='600' fontSize='24px' lineHeight='29px'>{data?.m_mobile || "--"}</Typography>
                                <div style={{display:"flex",justifyContent:"flex-end"}}>

                                <a href={`tel:${data?.m_mobile}`}><img src={CallIcon} width="40%" /></a>
                                    


                                <a href={`https://wa.me/${data?.m_mobile}`}><img src={WhatsAppIcon} width="40%" /></a>

                                    

                                </div>

                            </Stack>

                        </Stack>

                    </CardContent>

                </Card>
            </Grid>

        </>
    )
}
